import { render } from "./WpeExtensions.vue?vue&type=template&id=0b3b41e0"
import script from "./WpeExtensions.vue?vue&type=script&lang=js"
export * from "./WpeExtensions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/WpeExtensions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b3b41e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b3b41e0', __exports__)) {
    api.reload('0b3b41e0', __exports__)
  }
  
  module.hot.accept("./WpeExtensions.vue?vue&type=template&id=0b3b41e0", () => {
    api.rerender('0b3b41e0', render)
  })

}


export default __exports__